// Ubicación en el repo: src/lib/hearingaidControls.js
// Controles/calibraciones de audífono (tabla `hearingaid_controls`) — Fase 2
// del módulo Audífonos (ver DECISIONS.md). El alta agrega automáticamente
// una cita "Control audífono" en Agenda, y la baja/edición de fecha-hora
// quedan sincronizadas con esa cita — todo eso lo hace el trigger
// trg_hearingaid_controls_appointment_sync (migración 0002), no hay que
// tocar `appointments` desde acá.
import { supabase } from './supabaseClient';

const CONTROL_SELECT =
  'id, hearing_aid_id, date, time, notes, done, status, appointment_id, professional_id, ' +
  'professionals!professional_id(nombre, apellido)';

export async function listControlsForHearingAid(hearingAidId) {
  const { data, error } = await supabase
    .from('hearingaid_controls')
    .select(CONTROL_SELECT)
    .eq('hearing_aid_id', hearingAidId)
    .is('deleted_at', null)
    .order('date', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

// Mismos campos que addControlPrompt()/saveControl() del prototipo (línea
// ~3258 de prototipo-actual.html.html): fecha, hora, notas — más
// `professional_id` (opcional, ver DECISIONS.md #31: se puede dejar "sin
// asignar" y completarlo después en Agenda). El appointment_id lo completa
// el trigger al insertar.
export async function createControl({ hearingAidId, date, time, notes, professionalId }, actorId) {
  const { error } = await supabase.from('hearingaid_controls').insert({
    hearing_aid_id: hearingAidId,
    date,
    time: time || '09:00',
    notes: notes?.trim() || null,
    professional_id: professionalId || null,
    created_by: actorId,
  });
  if (error) throw error;
}

// El checkbox "hecho" del panel escribe `done` y `status` juntos — esto es
// lo que permite revertir un "No se presentó" marcado por error: si el
// paciente llega atrasado, tildar acá pasa la cita directo a "Atendido"
// (ver DECISIONS.md #33).
export async function toggleControlDone(id, done) {
  const { error } = await supabase
    .from('hearingaid_controls')
    .update({ done, status: done ? 'Atendido' : 'Pendiente' })
    .eq('id', id);
  if (error) throw error;
}

// Baja lógica — el trigger cascada automáticamente la cita asociada en
// Agenda (mismo criterio que deleteControl() del prototipo, que también
// borraba la cita al eliminar el control).
export async function softDeleteControl(id, actorId) {
  const { error } = await supabase
    .from('hearingaid_controls')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

// Mismo criterio que renderAudifonos() del prototipo (línea ~3068): el
// control pendiente (done=false) más próximo, ordenado por fecha.
export function nextPendingControl(controls) {
  const pending = (controls || []).filter((c) => !c.done).sort((a, b) => a.date.localeCompare(b.date));
  return pending[0] || null;
}
